var _clientEvaluationLanguages;
var _userClientEvaluationLanguages;

function UpdateEvaluatorList() {
    $.ajax({
        url: '/admin/manage',
        type: 'POST',
        data: {
            __RequestVerificationToken: $("[name='__RequestVerificationToken']").val()
        },
        success: function (response) {
            $("#managePartial").replaceWith(response);
            setTable();
        },
        error: function (xhr) {
            console.log(xhr.responseText);
        }
    });
}

function showEvaluatorToModify(userId, userFirstName, userLastName, userPhoneNumber, userEmail, userRole, userRoleName, userLanguage, userTimezone, clientId, defaultLanguage, userClientEvaluationLanguages, clientEvaluationLanguages) {
    _clientEvaluationLanguages = clientEvaluationLanguages;

    userClientEvaluationLanguages = eval(userClientEvaluationLanguages);
    _userClientEvaluationLanguages = userClientEvaluationLanguages;

    $("#firstNameToModify").val(userFirstName);
    $("#lastNameToModify").val(userLastName);
    $("#phoneNumberToModify").val(userPhoneNumber);
    $("#emailToModify").val(userEmail);
    $("#roleToModify").val(userRole);
    $("#languageToModify").val(userLanguage);

    $('input[name="languagesToModify"]').prop("checked", false);
    $('input[name="defaultLanguagesToModify"]').prop("checked", false);
    $('input[name="defaultLanguagesToModify"]').addClass("d-none");
    $('.optional-languagesToModify-radio-labels').addClass("d-none");
    $('.default-languagesToModify-radio-labels').addClass("d-none");

    $.each(JSON.parse(userLanguage), function (index, value) {
        $('input[name="languagesToModify"][value="' + value + '"]').prop("checked", true);
        $('input[name="defaultLanguagesToModify"][value="' + value + '"]').removeClass("d-none");
        $('.optional-languagesToModify-radio-labels[value="' + value + '"]').removeClass("d-none");

        if (value == defaultLanguage) {
            $('input[name="defaultLanguagesToModify"][value="' + value + '"]').prop("checked", true);
            $('.optional-languagesToModify-radio-labels[value="' + value + '"]').addClass("d-none");
            $('.default-languagesToModify-radio-labels[value="' + value + '"]').removeClass("d-none");
        }
    });

    var langId = getCurrentLang();

    var treeSource = clientEvaluationLanguages.map(c => ({
        title: c.name,
        key: 'c_' + c.id,
        "checkbox": true,
        "unselectable": false,
        children: c.clientEvaluations.map(ce => ({
            title: ce.evaluation.translations.find(_ => _.langId == langId).name,
            key: 'ce_' + ce.id,
            "checkbox": true,
            "unselectable": false,
            children: ce.clientEvaluationLanguages.map(cel => ({
                title: cel.language.name,
                key: 'cel_' + cel.id,
                "checkbox": true,
                "unselectable": false,
                "selected": _userClientEvaluationLanguages.find(_ => _ == cel.id) != undefined
            }))
        }))
    }));

    $("#clientEvaluationLanguagesToModify").fancytree({
        source: [],
        selectMode: 3
    });

    $('#clientEvaluationLanguagesToModify').fancytree('getTree').reload([
        {
            title: "Clients", key: "2", children: treeSource
        }
    ]); // hotfix to force reload when returning, otherwise the treeview doesn't update.

    $("#timezoneToModify").val(userTimezone);

    $("#updateUserPartial").dialog({
        buttons: {
            OK: function () {
                var selectedEvaluationLangs = $("#clientEvaluationLanguagesToModify").fancytree("getTree").getSelectedNodes().filter(_ => _.key.includes('cel_')).map(_ => parseInt(_.key.split('cel_')[1]));

                _userClientEvaluationLanguages = selectedEvaluationLangs;//[...new Set([..._userClientEvaluationLanguages, ...selectedEvaluationLangs])];
               
                if ($("#updateUserForm").valid()) {
                    var data = {
                        Id: userId,
                        FirstName: $("#firstNameToModify").val(),
                        LastName: $("#lastNameToModify").val(),
                        PhoneNumber: $("#phoneNumberToModify").val(),
                        Email: $("#emailToModify").val(),
                        LanguagesId: $('input[name="languagesToModify"]:checked').map(function () {
                            return parseInt(this.value);
                        }).get(),
                        DefaultLanguageId: parseInt($("input[name=defaultLanguagesToModify]:checked").val()) || 0,
                        TimezoneOffset: $("#timezoneToModify").find(":selected").val(),
                        ClientEvaluationLanguageUserIds: _userClientEvaluationLanguages
                    };

                    $.ajax({
                        url: '/api/admin/UpdateUser',
                        type: 'POST',
                        data: JSON.stringify(data),
                        contentType: 'application/json; charset=utf-8',
                        success: function (response) {

                            $("#userUpdatedAlert").removeClass("d-none");
                            $("#userUpdatedAlert").removeClass("hide");
                            $("#userUpdatedAlert").addClass("show");
                            setTimeout(function () {
                                $("#userUpdatedAlert").removeClass("show");
                                $("#userUpdatedAlert").addClass("hide");
                                $("#userUpdatedAlert").addClass("d-none");
                            }, 5000);

                            //UpdateEvaluatorList();
                        },
                        error: function (xhr) {
              
                            try {
                                $("#emailToModifyError").html(xhr.responseJSON.errors.Email[0]);
                            } catch (err) { }
                            try {
                                $("#roleToModifyError").html(xhr.responseJSON.errors.RoleId[0]);
                            } catch (err) { }
                            try {
                                $("#languageToModifyError").html(xhr.responseJSON.errors.LanguagesId[0]);
                            } catch (err) { }
                            try {
                                $("#defaultLanguageToModifyError").html(xhr.responseJSON.errors.DefaultLanguageId[0]);
                            } catch (err) { }
                            try {
                                $("#timezoneToModifyError").html(xhr.responseJSON.errors.TimezoneOffset[0]);
                            } catch (err) { }
                            try {
                                $("#clientIdToModifyError").html(xhr.responseJSON.errors.ClientId[0]);
                            } catch (err) { }

                            $("#userNotUpdatedAlert").removeClass("d-none");
                            $("#userNotUpdatedAlert").removeClass("hide");
                            $("#userNotUpdatedAlert").addClass("show");
                            setTimeout(function () {
                                $("#userNotUpdatedAlert").removeClass("show");
                                $("#userNotUpdatedAlert").addClass("hide");
                                $("#userNotUpdatedAlert").addClass("d-none");
                            }, 5000);

                            showOrHideClientInput();

                            //alert(xhr.responseText);
                        }
                    }).done(function () {
                        UpdateEvaluatorList();
                    }).fail(function () {
                        UpdateEvaluatorList();
                    });

                }
            }
        },
        open: function (e) {

            $(this).parent().addClass("dialog-open");
            $($(this).parent().find(".ui-dialog-buttonset").children()[0]).addClass("btn btn-primary btn-lg");
            $(".ui-dialog-buttonset").addClass("text-center");
        },
        close: function (e) {
            $(this).parent().removeClass("dialog-open");
            $("#evaluatorTestSelectionModeToModify").val("1"); // all
            $("#evaluationFilterClientNameToModify").val("");
        },
    })
};

function loadClientEvaluationTree(treeElem, treeData, modeElem) {
    var selectedEvaluationLangs = treeElem.fancytree("getTree").getSelectedNodes().filter(_ => _.key.includes('cel_')).map(_ => parseInt(_.key.split('cel_')[1]));

    _userClientEvaluationLanguages = _userClientEvaluationLanguages.filter(_ =>
        treeElem.fancytree("getTree").getNodeByKey("cel_" + _) == null ||
        (treeElem.fancytree("getTree").getNodeByKey("cel_" + _) != null && treeElem.fancytree("getTree").getNodeByKey("cel_" + _).selected)
    );

    _userClientEvaluationLanguages = [...new Set([..._userClientEvaluationLanguages, ...selectedEvaluationLangs])];

    switch (modeElem.val()) {
        case "2": //only show selected
            treeData = treeData.filter(c => c.clientEvaluations.some(ce => ce.clientEvaluationLanguages.some(cel => _userClientEvaluationLanguages.indexOf(cel.id) != -1)));
            break;
        case "3": //only show unselected
            treeData = treeData.filter(c => c.clientEvaluations.some(ce => ce.clientEvaluationLanguages.some(cel => _userClientEvaluationLanguages.indexOf(cel.id) == -1)));
            break;
    }

    var langId = getCurrentLang();

    var treeSource = treeData.map(c => ({
        title: c.name,
        key: 'c_' + c.id,
        "checkbox": true,
        "unselectable": false,
        children: c.clientEvaluations.map(ce => ({
            title: ce.evaluation.translations.find(_ => _.langId == langId).name,
            key: 'ce_' + ce.id,
            "checkbox": true,
            "unselectable": false,
            children: ce.clientEvaluationLanguages.map(cel => ({
                title: cel.language.name,
                key: 'cel_' + cel.id,
                "checkbox": true,
                "unselectable": false,
                "selected": _userClientEvaluationLanguages.indexOf(cel.id) != -1
            }))
        }))
    }));

    treeElem.fancytree({
        source: [],
        selectMode: 3
    });

    treeElem.fancytree('getTree').reload([
        {
            title: "Clients", "expanded": true, children: treeSource
        }
    ]);
}

var timerNameToModifyId;
function filterTests(treeElem, modeElem, clientNameElem) {
    var value = clientNameElem.val();

    if (clientNameElem.data("lastval") != value || modeElem.data("lastval") != modeElem.val()) {
        clientNameElem.data("lastval", value);
        modeElem.data("lastval", modeElem.val());
        clearTimeout(timerNameToModifyId);

        timerNameToModifyId = setTimeout(function () {

            var treeData = _clientEvaluationLanguages.filter(_ => _.name.toLowerCase().indexOf(value.toLowerCase()) != -1);

            loadClientEvaluationTree(treeElem, treeData, modeElem)
        }, 500);
    }
}

$("#evaluationFilterClientNameToModify").on("input", function (e) {
    filterTests($("#clientEvaluationLanguagesToModify"), $('#evaluatorTestSelectionModeToModify'), $("#evaluationFilterClientNameToModify"));
});

$('#evaluatorTestSelectionModeToModify').on('change', function () {
    filterTests($("#clientEvaluationLanguagesToModify"), $('#evaluatorTestSelectionModeToModify'), $("#evaluationFilterClientNameToModify"));
});

$("#evaluationFilterClientName").on("input", function (e) {
    filterTests($("#clientEvaluationLanguages"), $('#evaluatorTestSelectionMode'), $("#evaluationFilterClientName"));
});

$('#evaluatorTestSelectionMode').on('change', function () {
    filterTests($("#clientEvaluationLanguages"), $('#evaluatorTestSelectionMode'), $("#evaluationFilterClientName"));
});

function changeEvaluatorStatus(userId) {

    var data = {
        Id: userId
    };

    $.ajax({
        url: '/api/admin/UpdateUserStatus',
        type: 'POST',
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        success: function (response) {

            $("#evaluatorStatusUpdatedAlert").removeClass("d-none");
            $("#evaluatorStatusUpdatedAlert").removeClass("hide");
            $("#evaluatorStatusUpdatedAlert").addClass("show");
            setTimeout(function () {
                $("#evaluatorStatusUpdatedAlert").removeClass("show");
                $("#evaluatorStatusUpdatedAlert").addClass("hide");
                $("#evaluatorStatusUpdatedAlert").addClass("d-none");
            }, 5000);

        },
        error: function (xhr) {

            $("#evaluatorStatusUpdatedAlert").removeClass("d-none");
            $("#evaluatorStatusUpdatedAlert").removeClass("hide");
            $("#evaluatorStatusUpdatedAlert").addClass("show");
            setTimeout(function () {
                $("#evaluatorStatusUpdatedAlert").removeClass("show");
                $("#evaluatorStatusUpdatedAlert").addClass("hide");
                $("#evaluatorStatusUpdatedAlert").addClass("d-none");
            }, 5000);

            //alert(xhr.responseText);
        }
    }).done(function () {
    }).fail(function () {
        UpdateUserList();
    });
}

function confirmEvaluatorToDelete(userId) {
    $("#evaluatorIdToDelete").val(userId);
    $("#deleteModal").modal("show");
}

function deleteEvaluator() {
    var data = {
        Id: $("#evaluatorIdToDelete").val()
    };

    $.ajax({
        url: '/api/admin/DeleteEvaluator',
        type: 'POST',
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        success: function (response) {

            $("#evaluatorDeletedAlert").removeClass("d-none");
            $("#evaluatorDeletedAlert").removeClass("hide");
            $("#evaluatorDeletedAlert").addClass("show");
            setTimeout(function () {
                $("#evaluatorDeletedAlert").removeClass("show");
                $("#evaluatorDeletedAlert").addClass("hide");
                $("#evaluatorDeletedAlert").addClass("d-none");
            }, 5000);

        },
        error: function (xhr) {

            $("#evaluatorNotDeletedAlert").removeClass("d-none");
            $("#evaluatorNotDeletedAlert").removeClass("hide");
            $("#evaluatorNotDeletedAlert").addClass("show");
            setTimeout(function () {
                $("#evaluatorNotDeletedAlert").removeClass("show");
                $("#evaluatorNotDeletedAlert").addClass("hide");
                $("#evaluatorNotDeletedAlert").addClass("d-none");
            }, 5000);

            //alert(xhr.responseText);
        }
    }).done(function () {
        UpdateEvaluatorList();
        $("#evaluatorIdToDelete").val("");
        $("#deleteModal").modal("hide");
    }).fail(function () {
        UpdateEvaluatorList();
        $("#evaluatorIdToDelete").val("");
        $("#deleteModal").modal("hide");
    });
}